import PropTypes from 'prop-types';

import { BLOCK_LOCATIONS, LayoutRow, LayoutRowColumn, TextHeading } from '@ratehub/web-components';


function createBlogHeroBlocks(title) {
    return [
        {
            blockName: LayoutRow.blockKey,
            attrs: {
                blockLocation: BLOCK_LOCATIONS.HEADER,
                justifyContent: 'center',
                className: 'rh-pt-5 rh-pb-4',
            },
            innerBlocks: [
                {
                    blockName: LayoutRowColumn.blockKey,
                    innerBlocks: [
                        {
                            blockName: TextHeading.blockKey,
                            attrs: {
                                as: 'h1',
                                content: title,
                                className: 'showDot rh-title-4xl rh-my-2 rh-mx-0 rh-fg-blackberry',
                            },
                        },
                    ],
                },
            ],
        },
    ];
}

createBlogHeroBlocks.propTypes = {
    title: PropTypes.string.isRequired,
};

export default createBlogHeroBlocks;
